<template>
    
        <div class="container p-0" >
           
                <b-row>
                    <b-col  lg="6" md="6" sm="12">
                        <!--<b-img src="https://www.alluraa.com/media/brands/cl2.jpg" fluid alt="Responsive image" ></b-img> -->
						<kiwikkrrush-swiper></kiwikkrrush-swiper>
                    </b-col>
                    <b-col lg="6" md="6" sm="12" class="p-0">
                        <b-row class="m-0" >
                            <!--<SmallCarousel/> -->
							<brandsinfocus-swiper ></brandsinfocus-swiper>
                        </b-row>
                        <b-row class="m-0" >
						<b-link href="/brand/jaquline-usa">
                        <b-img  :src="$root.MEDIAPATH+'banners/jaquline-usa.jpg'" class="etbranndimg" ></b-img>
						</b-link>
                        </b-row> 
						
                    </b-col>
                </b-row>
           
        </div>
   
</template>
<script>
    //import SmallCarousel from './SmallCarousel.vue'
	import brandsinfocus_swiper from "@/components/brandsinfocus-swiper.vue";
	import kiwikkrrush_swiper from "@/components/kiwikkrrush-swiper.vue";

    export default {
        name: 'HeroCarousel',
        components: {
		"brandsinfocus-swiper": brandsinfocus_swiper,
		"kiwikkrrush-swiper": kiwikkrrush_swiper,
		},
    }
</script>
<style>
    
</style>